module.exports = __webpack_public_path__ + "img/mapField.52fbfd54.png";